import { render, staticRenderFns } from "./BuildPDF.vue?vue&type=template&id=c830c44e"
import script from "./BuildPDF.vue?vue&type=script&lang=js"
export * from "./BuildPDF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports